export var PublicRoute;
(function (PublicRoute) {
    PublicRoute["VERSION"] = "/version";
})(PublicRoute || (PublicRoute = {}));
